
import logo from '@src/assets/images/logo/logo.png'
import "./fallbackimage.css"

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner vh-100'>
      <img className='fallback-logo rotate-fallback-image' src={logo} alt='logo' />
    </div>
  )
}

export default SpinnerComponent
